import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  creditCount: 0,
  fieldErrors: null,
  isConfirmModalOpen: false,
  learnerEmail: '',
  otherReasonInput: '',
  reason: null,
  transactionType: 'ADD',
};

export const creditManagement = createSlice({
  name: 'creditManagement',
  initialState,
  reducers: {
    setConfirmModalOpen: (state, action) => {
      state.isConfirmModalOpen = action.payload;
    },
    setCreditCount: (state, action) => {
      state.creditCount = action.payload;
    },
    setFieldErrors: (state, action) => {
      state.fieldErrors = action.payload;
    },
    setLearnerEmail: (state, action) => {
      state.learnerEmail = action.payload;
    },
    setOtherReasonInput: (state, action) => {
      state.otherReasonInput = action.payload;
    },
    setReason: (state, action) => {
      state.reason = action.payload;
    },
    setTransactionType: (state, action) => {
      state.transactionType = action.payload;
    },
  },
});

export const {
  setCreditCount,
  setConfirmModalOpen,
  setFieldErrors,
  setLearnerEmail,
  setOtherReasonInput,
  setReason,
  setTransactionType,
} = creditManagement.actions;

export default creditManagement.reducer;
